import { Text, View, StyleSheet } from 'react-native';
import React, { Component } from 'react';
import WifiIcon1 from '../../../assets/images/wifi-outline-1.svg';
import WifiIcon2 from '../../../assets/images/wifi-outline-2.svg';
import WifiIcon3 from '../../../assets/images/wifi-outline-3.svg';
import WifiIconNoInternet from '../../../assets/images/wifi-no-internet.svg';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { Button, ButtonSize, ButtonTypes } from '../../../components';

export default class NetworkTile extends Component {
  getWifiIcon = (givenStrength) => {
    const bars = Math.ceil(givenStrength * 3);
    const { isActiveConnection = false, hasInternet = false } = this.props;
    if (!hasInternet && isActiveConnection) {
      return (
        <WifiIconNoInternet
          width={defaultScale(30)}
          height={defaultScale(30)}
          style={styles.iconStyle}
        />
      );
    }

    if (bars === 3) {
      return (
        <WifiIcon3
          width={defaultScale(30)}
          height={defaultScale(30)}
          style={styles.iconStyle}
        />
      );
    } else if (bars === 2) {
      return (
        <WifiIcon2
          width={defaultScale(30)}
          height={defaultScale(30)}
          style={styles.iconStyle}
        />
      );
    }
    return (
      <WifiIcon1
        width={defaultScale(30)}
        height={defaultScale(30)}
        style={styles.iconStyle}
      />
    );
  }

  handleTileMethod = () => {
    const { ssid, isProtected, isActiveConnection, navigation, handleForgetNetwork, afterNetworkAdded } = this.props;

    if (isActiveConnection) {
      handleForgetNetwork();
      return;
    }
    navigation.navigate('ConnectToWifi', { ssid, isProtected, afterNetworkAdded });
  }

  render() {
    const {
      ssid,
      strength,
      t,
      isLastItem = false,
      isActiveConnection = false,
      hasInternet = false,
    } = this.props;
    return (
      <View style={[styles.container, {
         marginBottom: isLastItem ? defaultScale(50) : defaultScale(10),
      }]}>
        <View style={styles.textIconContainer}>
          {this.getWifiIcon(strength)}
          <View>
            <Text style={[(isActiveConnection) ? styles.networkNameText : styles.noInternetText]}>{ssid}</Text>
            {(!hasInternet && isActiveConnection) && (
              <Text style={styles.noInternetText}>{t('noInternetConnection')}</Text>
            )}
          </View>
        </View>
        <Button
          fontColor={Theme.PRIMARY}
          size={ButtonSize.NORMAL}
          buttonType={ButtonTypes.TRANSPARENT}
          title={!isActiveConnection ? t('connect') : t('forget')}
          onPress={this.handleTileMethod}
          containerStyle={styles.connectButton}
          overrideFontStyles={styles.connectButtonTextStyle}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: defaultScale(90),
    borderWidth: 1,
    borderRadius: 5,
    borderColor: Theme.GREY_MEDIUM_LIGHT,
    marginVertical: defaultScale(10),
    marginHorizontal: defaultScale(5),
  },
  textIconContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '60%',
  },
  networkNameText: {
    ...Theme.textStyle.bodyCopyBold,
  },
  noInternetText: {
    ...Theme.textStyle.bodyCopyReg,
  },
  iconStyle: {
    paddingHorizontal: defaultScale(35),
  },
  connectButton: {
    paddingHorizontal: defaultScale(30),
  },
  connectButtonTextStyle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.PRIMARY,
  },
});
